import React from 'react';

export default ({children}) => <section className={'help px-3'}>
  {children}
</section>;